/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Pearl_Owl_KnitInputs */

const en_sandy_pearl_owl_knit = /** @type {(inputs: Sandy_Pearl_Owl_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey History`)
};

const de_sandy_pearl_owl_knit = /** @type {(inputs: Sandy_Pearl_Owl_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfrage-Verlauf`)
};

/**
* | output |
* | --- |
* | "Survey History" |
*
* @param {Sandy_Pearl_Owl_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_pearl_owl_knit = /** @type {((inputs?: Sandy_Pearl_Owl_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Pearl_Owl_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_pearl_owl_knit(inputs)
	return de_sandy_pearl_owl_knit(inputs)
});